export const DEFAULT_ACTION = 'screen/HomeScreen/DEFAULT_ACTION';
export const UPDATE_INPUT = 'screen/HomeScreen/UPDATE_INPUT';

export const GET_DASHBOARD = 'screen/HomeScreen/GET_DASHBOARD';
export const GET_DASHBOARD_LOADING = 'screen/HomeScreen/GET_DASHBOARD_LOADING';
export const GET_DASHBOARD_SUCCESS = 'screen/HomeScreen/GET_DASHBOARD_SUCCESS';
export const GET_DASHBOARD_FAIL = 'screen/HomeScreen/GET_DASHBOARD_FAIL';